<template>
  <CCard>
    <CCardBody>
      <h5 class="text-primary">Speciality</h5>
      <div>
        <!-- <BasicPie
          :data="specialityChartData"
          :height="300"
          :showLegend="false"
        /> -->
        <GPie :data="specialityChartData" :keys="keys"/>
      </div>
    </CCardBody>
  </CCard>
</template>
<script>
import candidate from "@/containers/KSADashboard/candidate.json";
import BasicPie from "@/components/reusable/Charts/BasicPie.vue";
import GPie from "@/components/reusable/Charts/GPie.vue";
export default {
  name: "SpecialityChart",
  components: {
    BasicPie,
    GPie,
  },
  data() {
    const colors = ["#1B4965", "#5FA8D3", "#A2D5AB", "#FFC857"];
     const count = candidate.reduce((acc, item) => {
        if (!acc[item.Category]) {
          acc[item.Category] = 0;
        }
        acc[item.Category]++;
        return acc;
      }, {});
      const counts = Object.entries(count).map(([category, count], index) => ({
        name: category,
        value: count,
        backgroundColor: colors[index],
        borderColor: colors[index],
      }));
      const specialityChartData = counts.map((item) => ({
        name: item.name,
        value: item.value,
        backgroundColor: item.backgroundColor,
        borderColor: item.borderColor,
      }))||[];
    return {
      specialityChartData,
      keys: ['Speciality', 'No.of.Applications'],
    };
  },
};
</script>
